import {
  IonIcon,
  IonImg,
  IonPage,
  IonText,
  IonTitle,
} from '@ionic/react';
import classNames from 'classnames';
import { chevronBackOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

import webinarImg from '@/assets/icons/video.svg';
import LearningCard from '@/components/learning/LearningCard/LearningCard';
import { ROUTES_PATH } from '@/constants';
import {
  VideoItems,
  VideoResponse,
} from '@/interfaces/LearningInterface/LearningInterface';

import styles from './AllWebinars.module.scss';

export default function AllWebinars() {
  const history = useHistory();

  const [webinarList, setwebinarList] = useState<VideoItems[]>([]);

  const getWebinarsFromApi = async () => {
    try {
      const response = await fetch(
        'https://www.googleapis.com/youtube/v3/playlistItems?key=AIzaSyAb8W--TEpkE3oqvwi7XOXGznIh7vHK3_g&playlistId=PLP9ms8Ry_5Oa7nnk6BTyC7N7tmEM2-ecy&part=id,snippet,contentDetails,status',
      );
      const responseJson: VideoResponse = await response.json();
      setwebinarList(responseJson.items);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getWebinarsFromApi();
  }, []);

  return (
    <IonPage>
      <div className={styles.allWebinarsPage}>
        <div className={styles.titleWrapper}>
          <Link className={styles.backBtn} to={ROUTES_PATH.LEARNING}>
            <IonIcon slot="start" icon={chevronBackOutline} />
            Volver a formación
          </Link>
        </div>
        <div className={styles.contentWrapper}>
          <IonTitle className={styles.allWebinarsTitle}>Formación</IonTitle>
          <div className={styles.headerDivider} />
          <div className={styles.submenuWrapper}>
            <IonText className={styles.submenuText}>
              <IonImg src={webinarImg} className={styles.submenuImg} />
              Webinars
            </IonText>
            <IonText className={styles.submenuOtherText}>
              Saca el máximo potencial de tu plataforma con nuestros videos de
              formación.
            </IonText>
          </div>
          <div className={styles.webinarsSection}>
            <div className={classNames(styles.webinarsWrapper, styles.allWebinars)}>
              {webinarList.map((webinar: VideoItems, index) => (
                <LearningCard
                  key={index}
                  title={webinar?.snippet?.title}
                  imgUrl={webinar?.snippet?.thumbnails?.medium?.url}
                  smallTitle
                  cardClick={() => {
                    history.push({
                      pathname: `${ROUTES_PATH.WEBINAR_DETAIL}/${webinar?.id}`,
                      state: webinar,
                    });
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </IonPage>
  );
}
